document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bb-quiz]').forEach((quiz) => {
    const options = quiz.querySelectorAll('.mood-option');
    const products = quiz.querySelectorAll('.mood-product');
    const label = quiz.querySelector('[data-quiz-results] .eyebrow');
    products.forEach((p) => p.classList.add('is-hidden'));
    options.forEach((button) => {
      button.addEventListener('click', () => {
        options.forEach((b) => b.classList.remove('is-active'));
        button.classList.add('is-active');
        const mood = button.dataset.mood;
        let shown = 0;
        products.forEach((product) => {
          const tags = product.dataset.tags || '';
          const match = tags.includes(`|${mood}|`);
          product.classList.toggle('is-hidden', !match);
          if (match) shown += 1;
        });
        const moodTitle = button.querySelector('span') ? button.querySelector('span').textContent : mood;
        if (label) label.textContent = shown ? `Products for ${moodTitle}` : `No products tagged ${mood} yet`;
      });
    });
  });
});
